import { applicationService } from '@/projects/admin/services/application-service';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import CustomStore from 'devextreme/data/custom_store';
import { DataGrid } from 'devextreme-react/data-grid';
import { ROUTER_CONSTANTS } from '@/core/constants/common/router-constants';

const ApplicationModuleList = () => {
    const [store, setStore] = useState<CustomStore>();
    const dataGridRef = useRef<DataGrid>(null);
    useEffect(() => {
        setStore(new CustomStore({
            key: ['id'],
            load: applicationService.getApplicationModules,
            byKey: async (key, loadOptions: any) => {
                let returnObject = null;
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                    const objectsByID = (await applicationService.getApplicationModules(loadOptions))
                    returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                }
                return returnObject
            },
            remove: applicationService.deleteApplicationModule,
            useDefaultSearch: true
        }));
    }, [])


    const navigate = useNavigate();
    const goToEdit = (id: string) => {
        navigate(`/admin/${ROUTER_CONSTANTS.ADMIN.ApplicationModules}/${id}`, { state: { id: id } })
    }

    return (
        <div>
            <DataGridWrapper
                permissonCode='Admin.Application.Module'
                datasource={store}
                pagerVisible={true}
                filterVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath={'/admin/'+ ROUTER_CONSTANTS.ADMIN.ApplicationModuleCreate}
                props={{ id: 'application-module-list', ref: dataGridRef }}
                editingConfig={{
                    allowDeleting: true,
                    allowUpdating: true,
                    deleteMessageText: RemoveMessage('Account'),
                }}
                columns={[
                    { dataField: 'name', caption: t('module'), allowFiltering: true },
                    { dataField: 'application', caption: t('application'), allowFiltering: true },
                    {
                        dataField: 'order', caption: t('order'), sortOrder: "desc",
                        sortIndex: 0, visible: false
                    },
                    { dataField: 'featureCount', caption: t('features'), allowFiltering: true, width: 200 }
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: function (e: any) {
                            goToEdit(e.row?.data.id);
                        },
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
        </div>
    )
}
export default ApplicationModuleList